
export function getRecaptchaToken(action) {
    return new Promise((resolve, reject) => {
       if(!action) {
           reject('No action given for recaptcha token');
           return;
       }
       if(!window.recaptcha_site_key && window.recaptcha_site_key !== 0) {
           reject('No recaptcha site key found');
           return;
       }
        // grecaptcha is not loaded in local environments and form requests will not check it
       if(typeof grecaptcha !== 'object') {
           resolve('invalid_local_token');
           return;
       }
       grecaptcha.execute(window.recaptcha_site_key, { action })
            .then(token => {
                resolve(token);
            }, error => {
                reject(error);
            });
    });
}

export function loadRecaptcha() {
    let baseUrl = 'https://www.google.com/recaptcha/api.js';
    let pageAction = window.Page || 'no_page_given';
    let script = document.createElement('script');
    $(document).ready(function () {
        if(document.getElementById('recaptchaBadge')) {
            window.recaptchaCallback = function() {
                var clientId = grecaptcha.render('recaptchaBadge', {
                    sitekey: window.recaptcha_site_key,
                    size: 'invisible',
                    badge: 'inline'
                });
                window.recaptcha_site_key = clientId;
                grecaptcha.execute(window.recaptcha_site_key, {action: pageAction});
            }
            script.src = `${baseUrl}?render=explicit&onload=recaptchaCallback`;
            document.body.appendChild(script);
            return;
        }
        script.src = `${baseUrl}?render=${window.recaptcha_site_key}`;
        document.body.appendChild(script);
        setTimeout(() => {
            grecaptcha.ready(() => {
                grecaptcha.execute(window.recaptcha_site_key, {action: pageAction});
            });
        }, 1000);
    });
}

export function formatPlacesAutocompleteResults(results) {
    if( ! results || ! results.address_components) {
        throw new Error('Invalid Google Places Automplete Results Given');
    }
    let full_address = results.formatted_address;
    let address, city, region, postal_code, street_number, route;
    for(let place of results.address_components) {
        if(place.types.indexOf('street_number') >= 0) {
            street_number = place.short_name;
            continue;
        }
        if(place.types.indexOf('route') >= 0) {
            route = place.short_name;
            continue;
        }
        if(place.types.indexOf('locality') >= 0) {
            city = place.long_name;
            continue;
        }
        if(place.types.indexOf('administrative_area_level_1') >= 0) {
            region = place.long_name;
            continue;
        }
        if(place.types.indexOf('postal_code') >= 0) {
            postal_code = place.long_name;
        }
    }
    if(street_number || route) {
        address = street_number + ' ' + route;
    }
    return { full_address, address, city, region, postal_code, street_number, route, results };
}
